import React from 'react';
import './LanguageTraining.css';
import mockup1 from '../assets/images/mockup-image1.webp';
import mockup2 from '../assets/images/mockup-image2.webp';
import playBadge from '../assets/images/google-play-badge.webp';
import ScrollReveal from '../components/ScrollReveal';

// Icon Components
const HistoryIcon = () => (
  <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 8v4l3 3" /><circle cx="12" cy="12" r="9" /><path d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" />
  </svg>
);

const AlphabetIcon = () => (
  <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 7V4h16v3M9 20h6M12 4v16" />
  </svg>
);

const MathIcon = () => (
  <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="2" width="16" height="20" rx="2" /><path d="M8 6h8M8 10h8M8 14h8M8 18h8" />
  </svg>
);

const BookIcon = () => (
  <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const AudioIcon = () => (
  <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" /><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
  </svg>
);

const DigitalIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" />
  </svg>
);

const MoneyIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8M12 18V6" />
  </svg>
);

export default function LanguageTraining() {
  const openLanguageHistoryInNews = () => {
    window.history.pushState({}, '', '/news?article=language');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const openAlphabetInNews = () => {
    window.history.pushState({}, '', '/news?article=alphabet');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const openNumbersInNews = () => {
    window.history.pushState({}, '', '/news?article=numbers');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <div className="lt-page" lang="si">
      {/* Hero Section */}
      {/* Hero Section */}
      <ScrollReveal>
        <section className="lt-hero">
          <div className="lt-hero-content">
            <p className="lt-hero-intro">
              කොරියන් සර් භාෂා හුරුව මගින් ඔබට පහත කරුණු අනාවරණය කර දෙනු ලැබේ.
            </p>
          </div>

          <div className="lt-grid-top">
            <div className="lt-card-white">
              <div className="lt-card-icon-box blue"><HistoryIcon /></div>
              <h3 className="lt-card-title">කොරියානු භාෂා ඉතිහාසය</h3>
              <p className="lt-card-text">
                කොරියානු ජාතිකයින් ජීවත්වීමට හුරුවී සිටින්නේ ඔවුන්ටම ආවේනික වූ ඔවුන්ටම අනන්‍ය වූ ජීවන තත්වයන් මතය. එම බැවින් ඔවුන්ගේ භාෂා ඉතිහාසය විග්‍රහ කිරීමේදී ඔවුන්ගේ සංස්කෘතිය පිළිබඳව අවබෝධයක් ලබාගත යුතු වේ.
              </p>
              <button className="lt-read-more" onClick={openLanguageHistoryInNews}>READ MORE</button>
            </div>

            <div className="lt-card-white">
              <div className="lt-card-icon-box red"><AlphabetIcon /></div>
              <h3 className="lt-card-title">කොරියානු අක්ෂර මාලාව</h3>
              <p className="lt-card-text">
                කොරියානු භාෂාව ලෝකයේ පවතින සරලතම භාෂාවන්ගෙන් එකකි. මෙය නිර්මාණය කිරීමට හේතුව හඳුනාගෙන ඉගෙනීම මඟින් ඉතා ඉක්මනින් ඔබට මෙම භාෂාව පිළිබඳව අවබෝධයක් ලබාගත හැකිය.
              </p>
              <button className="lt-read-more" onClick={openAlphabetInNews}>READ MORE</button>
            </div>

            <div className="lt-card-white">
              <div className="lt-card-icon-box green"><MathIcon /></div>
              <h3 className="lt-card-title">කොරියන් ගණිත ක්‍රම හා නිශ්චය ක්‍රම</h3>
              <p className="lt-card-text">
                අපගේ දෛනික ජීවිතයේ දී භාවිතා වන ගණිත ක්‍රම මෙන්ම සුවිශේෂී ප්‍රමාණ මැනීමේ ක්‍රම ද කොරියානු භාෂාව ඉගෙනීමේ දී අනිවාර්යයෙන්ම අධ්‍යනය කළ යුතුවේ. දිනය, වේලාව, කාසී වැනි කරුණු මෙහිදී විග්‍රහ කෙරේ.
              </p>
              <button className="lt-read-more" onClick={openNumbersInNews}>READ MORE</button>
            </div>
          </div>
        </section>
      </ScrollReveal>

      {/* Blue Banner Section */}
      {/* Blue Banner Section */}
      <ScrollReveal>
        <section className="lt-banner-blue">
          <div className="lt-banner-content">
            <div className="lt-banner-mockups">
              <img src={mockup2} alt="App UI" className="banner-mockup-img" />
              <div className="banner-character">
                <svg viewBox="0 0 24 24" width="64" height="64" fill="#2563eb"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/></svg>
              </div>
              <img src={mockup1} alt="App UI" className="banner-mockup-img" />
            </div>
            <p className="lt-banner-tagline">" කොරියන් සර් " කොරියාවට යන ඔබේ සිහින සැබෑ කරන එකම තැන.</p>
          </div>
        </section>
      </ScrollReveal>

      {/* Free Lessons Section */}
      {/* Free Lessons Section */}
      <ScrollReveal>
        <section className="lt-lessons">
          <h2 className="lt-section-title">
            කොරියන් භාෂාව ඉගෙනීම සඳහා මූලිකව ම අධ්‍යනය කළ යුතු සියලු පාඩම් ඔබට මෙහිදී නොමිලේ ලබා ගත හැකිය
          </h2>
          <div className="lt-lessons-grid">
            <div className="lt-card-light-blue">
              <div className="lt-card-icon-circle"><BookIcon /></div>
              <h4 className="lt-lesson-title">කොරියන් මුලික පාඩම් මාලාව</h4>
              <p className="lt-lesson-desc">
                කොරියන් භාෂාව ඉගෙනීමට අවශ්‍ය මූලිකව ම අධ්‍යනය කළ යුතු සියලු පාඩම් ඔබට මෙහිදී නොමිලේ ලබා ගත හැකිය
              </p>
              <a href="https://drive.google.com/drive/folders/11_iIuPizIDkdJmbTjPkT8ofzUHiyWRuj" target="_blank" rel="noopener noreferrer" className="lt-download-btn">Download</a>
            </div>

            <div className="lt-card-light-blue">
              <div className="lt-card-icon-circle"><AudioIcon /></div>
              <h4 className="lt-lesson-title">ප්‍රශ්න-පිළිතුරු හා හඬ පුහුණුව</h4>
              <p className="lt-lesson-desc">
                කොරියන් භාෂාව ඉගෙනීමට අවශ්‍ය මූලිකව ම අධ්‍යනය කළ යුතු සියලු - හඬ පුහුණුව ප්‍රශ්න හා පිළිතුරු සියල්ල මෙතැනින්
              </p>
              <a href="https://drive.google.com/drive/folders/15VhiIY7m-pFBFO_dTg-B0tfXD93OLbNS" target="_blank" rel="noopener noreferrer" className="lt-download-btn">Download</a>
            </div>
          </div>
        </section>
      </ScrollReveal>

      {/* Final Info Section */}
      {/* Final Info Section */}
      <ScrollReveal>
        <section className="lt-final-info">
          <div className="lt-info-container">
            <div className="lt-info-visual">
              <a href="https://play.google.com/store/apps/details?id=com.aeonian.koreansirapp&hl=en" target="_blank" rel="noopener noreferrer" className="google-play-card">
                <span className="gp-text">Google Play</span>
                <p className="gp-sub">නොමිලේ ලබා ගන්න</p>
                <div className="gp-badge-wrap">
                  <img src={playBadge} alt="Get it on Google Play" className="gp-badge-img" />
                </div>
              </a>
            </div>
            
            <div className="lt-info-text-list">
              <div className="lt-info-item">
                <div className="lt-info-icon purple"><DigitalIcon /></div>
                <div className="lt-info-content">
                  <h4 className="lt-info-title">ඩිජිටල් අත්දැකීම</h4>
                  <p className="lt-info-desc">
                    කොරියන් විෂය මාලාව නිසා ම මීට පෙර පන්තියකින් නිර්මාණය කරන ලද මෙම ඩිජිටල් ගුරුවරයා ඔබට සැබෑ එක් එක් කරුණුවලදී ඩිජිටල් අත්දැකීමක් ඔබට ලබා දෙන්නෙමු.
                  </p>
                </div>
              </div>

              <div className="lt-info-item">
                <div className="lt-info-icon sky"><MoneyIcon /></div>
                <div className="lt-info-content">
                  <h4 className="lt-info-title">අමතර වියදම්</h4>
                  <p className="lt-info-desc">
                    කොරියානු භාෂා ශිල්පය නිවසටම ගෙන ඒමට මෙන්ම ඉතාමත් අවම නිවැරදි නිපුණත්වයක් ලබාදීම අමතර පන්ති සදහා වැය වන අනවශ්‍ය මුදල් සහ කාලය ඉතිරි කර ගනිමින් නිවසේ සිටම කොරියානු භාෂාව ඉගෙන ගැනීමට අවස්ථාව සලසා දී ඇත.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </ScrollReveal>
    </div>
  );
}
